$(document).ready(function(){
var article = document.querySelector(".CaptureAllArticleContent");
var paragraphs = document.querySelectorAll(".CaptureAllArticleContent p");
var readtimediv = document.querySelector(".readTime");

const readgetTime = () => {
var numberOfWords = 0;
const averageWPM = 250;

paragraphs.forEach(function(paragraph) {
numberOfWords += paragraph.innerHTML.split(" ").length;
 
let readTime = numberOfWords / averageWPM; 


if (numberOfWords > 7721){
  readtimediv.innerHTML = ("6 min");
}else 
  readtimediv.innerHTML = Math.round(readTime) + " min ";
});

}

readgetTime();
 
  $(".author-main-article-wrapper").slick({
  slidesToShow: 3,
  infinite:false,
  slidesToScroll: 1,
  dots: false,
  responsive: [{breakpoint: 2880,settings:{slidesToShow: 3,slidesToScroll: 1,infinite: true,adaptiveHeight: true,arrows: true,dots: false}},
             {breakpoint: 768,settings: {slidesToShow: 1,slidesToScroll: 2,infinite: true,adaptiveHeight: true,arrows: false,dots: false}},
             {breakpoint: 480,settings: {slidesToShow: 1,slidesToScroll: 1,infinite: true,adaptiveHeight: true,arrows: false,dots: false}}]
  });  
  
 $('.mobile_heading-summary').on('click', function() {
    $(this).parents('.summary-wrapper_box').toggleClass('active');
  });

    $('.cv-content-article').children('h2').each(function(){
      var GetHtmlHSecond = $(this).html().replace(/\s+/g, '-').toLowerCase().replace(/&nbsp;/g, '').replace(/:/g,'').replace('.', '').replace('?','').replace("'", "-").replace(",", "-");
      $(this).attr('id',GetHtmlHSecond).addClass('handleFetch');
    });
    $('.CaptureAllArticleContent').children('h1').each(function(){
      var GetHtmlHSecond = $(this).html().replace(/\s+/g, '-').toLowerCase().replace(/&nbsp;/g, '').replace(/:/g,'').replace('.', '').replace('?','').replace("'", "-").replace(",", "-");
      $(this).attr('id',GetHtmlHSecond).addClass('handleFetch');
    });
    $('.CaptureAllArticleContent').children('h2').each(function(){
      var GetHtmlHSecond = $(this).html().replace(/\s+/g, '-').toLowerCase().replace(/&nbsp;/g, '').replace(/:/g,'').replace('.', '').replace('?','').replace("'", "-").replace(",", "-");
      $(this).attr('id',GetHtmlHSecond).addClass('handleFetch');
    });
    $('.CaptureAllArticleContent').children('h3').each(function(){
     var GetHtmlHSecond = $(this).html().replace(/\s+/g, '-').toLowerCase().replace(/&nbsp;/g, '').replace(/:/g,'').replace('.', '').replace('?','').replace("'", "-").replace(",", "-");
      $(this).attr('id',GetHtmlHSecond).addClass('handleFetch');
    });
    $('.CaptureAllArticleContent').children('h4').each(function(){
      var GetHtmlHSecond = $(this).html().replace(/\s+/g, '-').toLowerCase().replace(/&nbsp;/g, '').replace(/:/g,'').replace('.', '').replace('?','').replace("'", "-").replace(",", "-");
      $(this).attr('id',GetHtmlHSecond).addClass('handleFetch');
    });

setInterval(function(){
  if($('.recentArticlesList .article').length > 0){
    $('.recentArticlesList .article').each(function(index){
      index = index + 1;
      var idHAndle = $(this).attr('id');
      if(index == 1 && idHAndle == ''){
        var appendHTMl = '<div class="emptyRecent">No Recent Articles</div>';
        $(this).html(appendHTMl)
      }
    })
  }
})

  $('.code-cv-article-slider').slick({slidesToShow: 1, arrows: true,dots: false,asNavFor:'.code-slider-thumbnail',fade:true,slidesToScroll: 1}); 
  $('.code-slider-thumbnail').slick({infinite: true,slidesToShow: 9,arrows:false,dots:false,asNavFor: '.code-cv-article-slider',slidesToScroll: 1,focusOnSelect: true});
  $('.custom-slider-popup-artice').slick({slidesToShow: 1, arrows: true,dots: false,fade:true,slidesToScroll: 1}); 

  $('.article-open-popup').click(function(){
    $('.code-cv-article-slider').slick('refresh');
    $(this).parents('.cv-main-article-slider').children('.cv-article-image-popup').addClass('popup-article');
    $('body').addClass('body-article');
  });

  $('.close-slider-popup').click(function(){
    $(this).parents('.cv-main-article-slider').children('.cv-article-image-popup').removeClass('popup-article');
    $('body').removeClass('body-article')
  });

  $(".social-icon-article-left").css("display", "none");
  $('.slick-arrow').click(function(){
    $(".social-icon-article-left").css("display", "block");
  });
  
});

(function($) {
 
 $(window).on('resize', function() {
 if ($(window).width() < 749) {
  $('.cv_article_Slider').slick({
    dots: false,
    arrows: false,
    infinite: true,
    slidesToShow: 2
  });
   }else{
    $('.cv_article_Slider').slick('destroy');
   }
    });

})( jQuery );
